<template>
  <div class="glossary-dialog-container">
    <GlossariesList v-if="currentComponent === 'GlossariesList'" @open-glossary="editGlossary" />
    <GlossaryOverview
      v-else
      :glossary="selectedGlossary"
      :save-status="saveStatus"
      @navigate-back="cancelEdit"
      @save="handleSave"
    />
  </div>
</template>

<script>
import { ref } from 'vue';

import { GLOSSARY_SAVE_STATUS } from '~/constants/glossaries';
import useGlossaries from '~/composables/useGlossaries';
import GlossariesList from '~/components/glossary/GlossariesList';
import GlossaryOverview from '~/components/glossary/GlossaryOverview';

export default {
  components: { GlossaryOverview, GlossariesList },
  setup() {
    const { GLOSSARY_COMPONENT, saveGlossary } = useGlossaries();
    const selectedGlossary = ref(null);
    const currentComponent = ref(GLOSSARY_COMPONENT.list);
    const saveStatus = ref(null);

    const editGlossary = (glossary) => {
      selectedGlossary.value = { ...glossary };
      saveStatus.value = null;
      currentComponent.value = GLOSSARY_COMPONENT.overview;
    };

    // a failed save keeps the glossary and the edits on screen, so the user can try again
    const handleSave = async (headers, rows, glossary, publicValue, newName) => {
      saveStatus.value = GLOSSARY_SAVE_STATUS.SAVING;
      const savedGlossary = await saveGlossary(headers, rows, glossary, publicValue, newName);
      if (!savedGlossary) {
        saveStatus.value = GLOSSARY_SAVE_STATUS.ERROR;
        return;
      }
      selectedGlossary.value = savedGlossary;
      saveStatus.value = GLOSSARY_SAVE_STATUS.SAVED;
    };

    const cancelEdit = () => {
      selectedGlossary.value = null;
      saveStatus.value = null;
      currentComponent.value = GLOSSARY_COMPONENT.list;
    };

    return {
      cancelEdit,
      currentComponent,
      editGlossary,
      handleSave,
      saveStatus,
      selectedGlossary,
    };
  },
};
</script>

<style scoped lang="scss">
.glossary-dialog-container {
  /* Style your dialog/panel here */
  display: flex;
  flex-direction: column;
  height: 100vh; /* Take full viewport height */
  width: 100%;
  position: fixed; /* Use fixed positioning */
  top: 0;
  left: 0;
  z-index: 1000; /* Ensure it's above other content */
}
</style>
